(ns frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pages.fees-interest-expenses
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]))

(defn carried-interest-and-expenses-tables-1
  [{:keys [fund-status] :as data}]
  (let [remove-page? (and (empty-table-data? fund-status :management-fees)
                          (empty-table-data? fund-status :transaction-and-other-fees))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Fees"
                                   :toc-item   true})
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-status
                                                       :management-fees))
                        (text-content/optional-footer (->> fund-status
                                                           :management-fees)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-status
                                                       :transaction-and-other-fees))
                        (text-content/optional-footer (->> fund-status
                                                           :transaction-and-other-fees)))))))

(defn carried-interest-and-expenses-tables-2
  [{:keys [fund-status] :as data}]
  (let [remove-page? (and (empty-table-data? fund-status :carried-interest)
                          (empty-table-data? fund-status :fund-operating-expenses))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Carried interest and fund operating expenses"
                                   :toc-item   true})
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-status
                                                       :carried-interest))
                        (text-content/optional-footer (->> fund-status
                                                           :carried-interest)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-status
                                                       :fund-operating-expenses))
                        (text-content/optional-footer (->> fund-status
                                                           :fund-operating-expenses)))))))



(defn fees-interest-expenses
  [data]
  [(carried-interest-and-expenses-tables-1 data)
   (carried-interest-and-expenses-tables-2 data)])
